<template>
	<div class="ts-space-y-2">
		<fieldset>
			<legend class="text-blue">
				{{ $t('promotion.productLists') }}
				<Tooltip placement="top">
					<Icon type="ios-information-circle-outline" size="17" />
					<div slot="content">
						<div class="ts-text-xs">
							{{ $t('promotion.productLists') }}
						</div>
					</div>
				</Tooltip>
			</legend>
			<div class="ts-space-y-2">
				<div class="row filter">
					<div class="col-md-2">
						<a-select v-model="filter.type" :options="typeLists" class="ts-w-full" style="height: 30px;"
							placeholder="Type" @change="onChangeType"></a-select>
					</div>
					<div class="col-md-4">
						<a-select v-model="filter.pro_group_id" :options="productGroupFilters" show-search allowClear
							option-filter-prop="children" class="ts-w-full" style="height: 30px;"
							placeholder="Filter By Group" v-if="filter.type == 1"></a-select>
					</div>
					<div class="col-md-1"></div>
					<div class="col-md-5">
						<input v-model.trim="filter.search" type="text" :placeholder="$t('search')"
							class="form-control" />
					</div>
				</div>
				<ByItem v-model="model" :filter="filter" v-show="filter.type == 1" ref="byItem" />
				<ByGroup v-model="model" :filter="filter" v-show="filter.type == 2" ref="byGroup" />
			</div>
		</fieldset>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import ByItem from './product-list-by-item.vue'
import ByGroup from './product-list-by-group.vue'
export default {
	name: 'incentiveByAmountProductList',
	props: ['value'],
	components: {
		ByItem,
		ByGroup,
	},
	data() {
		return {
			filter: {
				type: 1,
				search: '',
				pro_group_id: undefined,
			},
			model: {},
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		...mapState('promotion/incentiveByAmount', ['formViewDatas']),
		productGroupFilters() {
			if (this.formViewDatas['productGroups']) {
				return this.formViewDatas['productGroups'].map(el => ({
					value: el.pro_group_id,
					label: el.pro_group_name_en + (el.pro_group_name_kh ? '|' + el.pro_group_name_kh : ''),
				}))
			}
			return []
		},
		typeLists() {
			return [
				{
					label: 'By Item',
					value: 1
				},
				{
					label: 'By Group',
					value: 2
				}
			]
		},
	},
	methods: {
		onChangeType(type) {
			if (type == 1) {
				this.$refs.byItem.onChangeType()
			}
			if (type == 2) {
				this.$refs.byGroup.onChangeType()
			}
		},
	},
}
</script>

<style scoped>
.form-control {
	height: 30px;
}
</style>
<style>
.filter .ant-select-selection--single {
	height: 29px;
}

.ivu-checkbox-small {
	margin: 0;
}
</style>